import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { AppContext } from 'store/AppContext';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import { Select, MenuItem, TextField, FormLabel, FormGroup, FormControl, FormControlLabel, Checkbox } from '@material-ui/core';
import { putAtkvaedi, getAtkvaediByKennitala } from 'common/services/apiService';
import PrintFylgibref from './PrintFylgibref';
import PrintUmslag from './PrintUmslag';


const BreytaAtkvaediDialog = (props) => {
  const { atkvaediDialogOpen, setAtkvaediDialogOpen, selectedAtkvaedi, setData, setSnackbarOpen } = props;
  const context = useContext(AppContext);
  const atkvaediOptions = context.atkvaediOptions.get;
  const [formState, setFormState] = useState({
    id: "",
    atkvaediTegundId: "",
    adstodKjorstjori: false,
    adstodFulltrui: false,
    adstodBlindur: false,
    adstodHond: false,
    vottord: false,
    athugasemd: "",
    ogilt: false,
    notandi: "",
    notandiKt: "",
  });
  const [showPrintActions, setShowPrintActions] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    setFormState(state => ({
      ...state,
      id: selectedAtkvaedi.atkvaedi.id,
      atkvaediTegundId: selectedAtkvaedi.atkvaedi.atkvaediTegundId,
      adstodKjorstjori: selectedAtkvaedi.atkvaedi.adstodKjorstjori,
      adstodFulltrui: selectedAtkvaedi.atkvaedi.adstodFulltrui,
      adstodBlindur: selectedAtkvaedi.atkvaedi.adstodBlindur,
      adstodHond: selectedAtkvaedi.atkvaedi.adstodHond,
      vottord: selectedAtkvaedi.atkvaedi.vottord,
      athugasemd: selectedAtkvaedi.atkvaedi.athugasemd,
      ogilt: selectedAtkvaedi.atkvaedi.ogilt,
      notandi: context.user.get.details.saml_username,
      notandiKt: context.user.get.details.saml_userssn,
    }));

  }, [selectedAtkvaedi, context]);

  // Cleanup adstod values if requirements are not met
  useEffect(() => {
    if (!formState.adstodKjorstjori && !formState.adstodFulltrui) {
      if (formState.adstodBlindur || formState.adstodHond) {
        setFormState(state => ({
          ...state,
          adstodBlindur: false,
          adstodHond: false
        }));
      }
    }
  }, [formState.adstodKjorstjori, formState.adstodFulltrui, formState.adstodBlindur, formState.adstodHond]);

  const handleClose = () => {
    setAtkvaediDialogOpen(false);
  }

  // TODO: should be refactored, no time at the moment.
  const handleCheckboxChange = name => e => {
    e.persist();
    if (name === "adstodKjorstjori")
      setFormState(state => ({ ...state, adstodKjorstjori: e.target.checked, adstodFulltrui: false }));
    else if (name === "adstodFulltrui")
      setFormState(state => ({ ...state, adstodFulltrui: e.target.checked, adstodKjorstjori: false }));
    else 
      setFormState(state => ({ ...state, [name]: e.target.checked })); // probably not needed.
    setShowPrintActions(false); // Assist with rerender of document to print
  }


  const handleValueChange = name => e => {
    e.persist();
    setFormState(state => ({ ...state, [name]: e.target.value}));
    setShowPrintActions(false); // Assist with rerender of document to print
  }

  async function handleSubmit() {
    const { httpStatus, isError, error } = await putAtkvaedi(
      formState.id,
      formState,
      context,
      {}
    );

    if (!isError) {
      setAtkvaediDialogOpen(false);
      setSnackbarOpen(true);
      handleRefreshAtkvaedi();
    } else {
      if (httpStatus === 400) {
        setIsError(true);
        setErrorMsg(error.title);
      } else {
        setIsError(true);
        setErrorMsg('Óvænt villa kom upp');
      }
    };
  }

  // Dirty way of refreshing the atkvaedi table
  async function handleRefreshAtkvaedi() {    
    const { data, isSuccess } = await getAtkvaediByKennitala(
      selectedAtkvaedi.atkvaedi.kennitala,
      context,
      []
    );

    if (isSuccess) {
      setData(data);
    }
  }

  return (
    <div>
      <Dialog
        open={atkvaediDialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          {`${selectedAtkvaedi.kosning.lysing}`}
        </DialogTitle>
        <DialogContent>
          <Grid
            container
            item
            spacing={2}
            direction="row"
            alignItems="flex-start"
            justify="flex-start"
          >
            <Grid item xs={4}>
              <Typography variant="caption">Nafn</Typography>
              <Typography>
                <strong>{selectedAtkvaedi.atkvaedi.nafn}</strong>
              </Typography>
              <Typography variant="caption">Heimili</Typography>
              <Typography>
                <strong>{selectedAtkvaedi.atkvaedi.heimili}</strong>
              </Typography>
              <Typography variant="caption">Tímastimpill</Typography>
              <Typography>
                <strong>
                  {moment(selectedAtkvaedi.atkvaedi.dagsetning).format(
                    "DD.MM.YYYY HH:mm"
                  )}
                </strong>
              </Typography>
              <Typography variant="caption">Atkvæði skráð af</Typography>
              <Typography>
                <strong>{selectedAtkvaedi.atkvaedi.notandi}</strong>
              </Typography>

              <div style={{ marginTop: "16px", marginBottom: "16px" }}>
                <Divider />
              </div>

              <Button
                color="primary"
                variant="text"
                onClick={() => setShowPrintActions(true)}
              >
                Útbúa nýtt fylgibréf / umslag
              </Button>
              {/** This is conditional to force re-render of document to print
               * Needed so props flow correctly to the document after they're changed
               */}
              {showPrintActions && (
                <div style={{ marginTop: "8px" }}>
                  <div>
                    <PrintFylgibref
                      formState={formState}
                      kjosandi={selectedAtkvaedi.kjosandi}
                      kosning={selectedAtkvaedi.kosning}
                    />
                  </div>
                  <div style={{ marginTop: "8px" }}>
                    <PrintUmslag
                      kjosandi={selectedAtkvaedi.kjosandi}
                      kosning={selectedAtkvaedi.kosning}
                    />
                  </div>
                </div>
              )}
            </Grid>

            <Divider orientation="vertical" flexItem />

            <Grid item xs={6}>
              <Grid item>
                <FormControl
                  component="fieldset"
                  style={{ marginBottom: "16px" }}
                >
                  <FormLabel component="legend">Tegund atkvæðis</FormLabel>
                  <FormGroup>
                    <Select
                      labelId="breyta-tegund-atkvaedi-select-label"
                      id="breyta-tegund-atkvaedi-select"
                      value={formState.atkvaediTegundId}
                      onChange={handleValueChange("atkvaediTegundId")}
                    >
                      {atkvaediOptions.map((o) => (
                        <MenuItem key={o.id} value={o.id}>
                          {o.lysing}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormGroup>
                </FormControl>
              </Grid>
              <Grid item>
                <FormControl component="fieldset">
                  <FormLabel component="legend">Aðstoð veitt af:</FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleCheckboxChange("adstodKjorstjori")}
                          value="adstodKjorstjori"
                          checked={formState.adstodKjorstjori}
                        />
                      }
                      label="Kjörstjóra"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleCheckboxChange("adstodFulltrui")}
                          value="adstodFulltrui"
                          checked={formState.adstodFulltrui}
                        />
                      }
                      label="Aðstoðarmanni kjósanda"
                    />
                  </FormGroup>
                </FormControl>
                {/* <FormControl component="fieldset">
                  <FormLabel component="legend">Aðstoð vegna:</FormLabel>
                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleCheckboxChange("adstodBlindur")}
                          value="adstodBlindur"
                          checked={formState.adstodBlindur}
                          disabled={
                            !(
                              formState.adstodKjorstjori ||
                              formState.adstodFulltrui
                            )
                          }
                        />
                      }
                      label="Sjónleysi kjósanda"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={handleCheckboxChange("adstodHond")}
                          value="adstodHond"
                          checked={formState.adstodHond}
                          disabled={
                            !(
                              formState.adstodKjorstjori ||
                              formState.adstodFulltrui
                            )
                          }
                        />
                      }
                      label="Hönd kjósanda ónothæf"
                    />
                  </FormGroup>
                </FormControl> */}
              </Grid>
              {/* <FormControl component="fieldset">
                <FormLabel component="legend">Vottorð:</FormLabel>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        onChange={handleCheckboxChange("vottord")}
                        value="vottord"
                        checked={formState.vottord}
                      />
                    }
                    label="Vottorð réttindagæslumanns"
                  />
                </FormGroup>
              </FormControl> */}
              <TextField
                id="breyta-atkvedi-athugasemd"
                label="Athugasemd"
                placeholder="Skrá athugasemd"
                style={{ marginTop: "24px" }}
                multiline
                rows="4"
                fullWidth
                variant="outlined"
                value={formState.athugasemd}
                onChange={handleValueChange("athugasemd")}
              />
              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={formState.ogilt}
                      onChange={handleCheckboxChange("ogilt")}
                      name="atkvaediOgilt"
                    />
                  }
                  label="Atkvæði ógilt"
                  style={{ marginTop: "8px" }}
                />
              </FormGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          {isError && (
            <Typography color="error">
              <strong>Villa: </strong>
              {errorMsg}
            </Typography>
          )}
          <Button onClick={handleClose}>Loka</Button>
          <Button color="primary" variant="contained" onClick={handleSubmit}>
            Breyta
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default BreytaAtkvaediDialog;
